import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmText,
  onConfirm,
  onCancel,
  danger = false,
}) {
  const { t } = useTranslation('admin')
  const resolvedConfirmText = confirmText || t('confirmDialog.confirm')
  // Trap focus and close on Escape
  useEffect(() => {
    if (!open) return
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onCancel()
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [open, onCancel])

  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black/40" onClick={onCancel} />
      <div className="relative bg-white rounded-xl p-6 shadow-xl max-w-md w-full animate-fadeIn">
        <h3 className="font-display text-xl font-medium text-gray-800 mb-2">
          {title}
        </h3>
        <p className="text-gray-600 mb-6">{message}</p>
        <div className="flex gap-3 justify-end">
          <button
            onClick={onCancel}
            className="px-5 py-2.5 text-sm font-semibold text-gray-700 bg-gray-100 rounded-lg transition-all hover:bg-gray-200"
          >
            {t('confirmDialog.cancel')}
          </button>
          <button
            onClick={onConfirm}
            className={`px-5 py-2.5 text-sm font-semibold text-white rounded-lg transition-all hover:shadow-lg ${
              danger
                ? 'bg-red-500 hover:bg-red-600'
                : 'bg-gradient-to-r from-primary-500 to-primary-600'
            }`}
          >
            {resolvedConfirmText}
          </button>
        </div>
      </div>
    </div>
  )
}
